"use client";

import React, { createContext, useContext, useState, lazy, Suspense } from 'react';
import LoginModal from '@/components/modals/LoginModal';

// 使用动态导入避免循环依赖
const PricingModal = lazy(() => import('@/components/modals/PricingModal'));

const ModalContext = createContext();

// 定义所有可用的模态框类型
const MODAL_COMPONENTS = {
  login: LoginModal,
  pricing: PricingModal,
  // 可以继续添加其他模态框类型
};

export function ModalProvider({ children }) {
  const [activeModal, setActiveModal] = useState(null);
  const [modalProps, setModalProps] = useState({});

  const openModal = (modalType, props = {}) => {
    setActiveModal(modalType);
    setModalProps(props);
  };

  const closeModal = () => {
    setActiveModal(null);
    setModalProps({});
  };

  // 获取当前应该显示的模态框组件
  const ModalComponent = activeModal ? MODAL_COMPONENTS[activeModal] : null;

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      {ModalComponent && (
        <Suspense fallback={<div>Loading...</div>}>
          <ModalComponent 
            isOpen={!!activeModal} 
            onClose={closeModal}
            {...modalProps}
          />
        </Suspense>
      )}
    </ModalContext.Provider>
  );
}

// 自定义hook用于访问modal context
export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}; 